import { Subscription } from 'rxjs';
import { Component, EventEmitter, OnInit, Output, Input, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { IAppState } from '@app/store';
import { PopinAuthShowed } from '@app/core/user/store/actions';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';
import { Credentials } from '@vestiaire/api-sdk-angular';
import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';
import * as reducers from '@app/core/user/store/reducers';
import { MatDialogRef } from '@angular/material/dialog';
import { NON_REGISTERED_FB_USER } from './../../store/actions/user.actions';

@Component({
  selector: 'vc-login-register-screen',
  templateUrl: './login-register-screen.component.html',
  styleUrls: ['./login-register-screen.component.scss']
})
export class LoginRegisterScreenComponent implements OnInit, OnDestroy {
  @Output()
  switchModal: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  onUserValidated = new EventEmitter<{ credentials: Credentials; firstname?: string }>();
  @Output()
  onClosePopin = new EventEmitter<any>();
  @Input()
  popinForced: boolean;
  @Input()
  promoOffer: string;

  isMobile = false;
  actionListener: Subscription;

  constructor(
    private store: Store<IAppState>,
    private helperService: HelpersService,
    private dialogRef: MatDialogRef<AuthModalComponent>,
    private action: Actions
  ) {}

  ngOnInit() {
    this.isMobile = !this.helperService.device.isMdUp();
    this.store.dispatch(
      new PopinAuthShowed({
        type: 'welcome',
        forced: this.popinForced,
        isMobile: this.isMobile
      })
    );

    this.actionListener = this.action.pipe(ofType(NON_REGISTERED_FB_USER)).subscribe({
      next: _ => {
        this.switchModal.emit('register');
      }
    });

    this.store.pipe(select(reducers.isAuthenticated)).subscribe(
      res => {
        if (res) {
          this.dialogRef.close();
        }
      },
      err => {
        // Silent catch error because we don't have anything to do
      }
    );
  }

  switchTo(type: 'login' | 'register') {
    this.switchModal.emit(type);
  }

  setUserFromFacebook(user: { credentials: Credentials; firstname?: string }) {
    this.onUserValidated.emit(user);
  }

  closePopin() {
    this.onClosePopin.emit();
  }

  ngOnDestroy() {
    this.actionListener?.unsubscribe();
  }
}
